import serviceV2 from "./serviceV2"

export default ($http, context) => ({
  httpSettlementIncome(item) {
    const queryParam = `/settlements/average_dencsity?duration=${item.duration}&resolution=${item.timePeriod}`
    return serviceV2.get($http, context, queryParam)
  },
})
